var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',{staticClass:"shadow bg-white p-b rounded-0",attrs:{"role":"tablist"}},_vm._l((_vm.menuFiltrado),function(item,i){return _c('b-list-group-item',{key:i,staticClass:"nav-link",class:_vm.pageAtual == item.tab ? 'active' : '',attrs:{"to":{
            name: 'familias_edit',
            params: {
                id: _vm.$route.params.id,
                aba: item.slug,
            },
        },"role":"tab"}},[_vm._v("\n        "+_vm._s(item.titulo)+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }